<nav class="h-12">
  <h1 class="self-center text-xl"><strong>NavReporting</strong> Performance</h1>
  @if (title()) {
    <h2 class="grow self-center text-xl">
      <span class="px-2">-</span>{{ title() }}
    </h2>
  }
  @if (authStore.isLoggedIn() && isMainLayout()) {
    <div class="flex">
      <re-vessel-selector />
      <re-user-menu [email]="authStore.email()" />
    </div>
  }
</nav>
